import useResizeObserver from "@bedrock-layout/use-resize-observer";
import React from "react";
const useContainterQuery = (node, width = 1, maxWidth) => {
  if (maxWidth !== void 0 && maxWidth <= width) {
    throw new Error(`The second width value, ${maxWidth}, is not larger than ${width}. Please provide a value greater than first width value`);
  }
  const [matches, setMatch] = React.useState(false);
  useResizeObserver((entry) => {
    var _a, _b;
    const nodeWidth = (_b = (_a = entry.borderBoxSize) == null ? void 0 : _a.inlineSize) != null ? _b : entry.contentRect.width;
    if (nodeWidth > 0) {
      const newMatch = maxWidth === void 0 ? nodeWidth <= width : nodeWidth >= width && nodeWidth <= maxWidth;
      setMatch(newMatch);
    }
  }, node);
  return matches;
};
export { useContainterQuery as default };
